    export const MESSAGE_TEMPLATE_CREATE_EDIT_OPEN_MODAL = "MESSAGE_TEMPLATE_CREATE_EDIT_OPEN_MODAL";
    export const MESSAGE_TEMPLATE_CREATE_REQUEST = "MESSAGE_TEMPLATE_CREATE_REQUEST";
    export const MESSAGE_TEMPLATE_CREATE_RESULT = "MESSAGE_TEMPLATE_CREATE_RESULT";
    export const MESSAGE_TEMPLATE_EDIT_REQUEST = "MESSAGE_TEMPLATE_EDIT_REQUEST";
    export const MESSAGE_TEMPLATE_EDIT_RESULT = "MESSAGE_TEMPLATE_EDIT_RESULT";
    export const MESSAGE_TEMPLATE_GET_REQUEST = "MESSAGE_TEMPLATE_GET_REQUEST";
    export const MESSAGE_TEMPLATE_GET_RESULT = "MESSAGE_TEMPLATE_GET_RESULT";